import React from 'react';
import { motion } from 'framer-motion';
const CART_URL = 'https://www.kmsinrendirse.shop/cart/add?id=51999668764955&quantity=1';
function trackAddToCart() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart');
  }
}
export function StickyBar() {
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-navy/90 backdrop-blur-md border-b border-accent/20" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-149">
        <div className="flex items-center gap-2 text-sm md:text-base font-semibold" data-id="element-150">
          <span className="text-2xl" data-id="element-151">🔥</span>
          <span className="text-white" data-id="element-152">50% OFF — Solo por tiempo limitado</span>
        </div>
        <a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-accent hover:bg-accent-dark text-white px-4 md:px-6 py-2 rounded-lg font-semibold text-sm md:text-base transition-all hover:scale-105" data-id="element-153">
          Ver Oferta
        </a>
      </div>
    </motion.div>;
}